import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-024a1209"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer__inner container--large" }
const _hoisted_3 = { class: "footer__tip" }
const _hoisted_4 = {
  href: "https://paypal.me/nkosakul?country.x=DE&locale.x=de_DE",
  target: "_blank",
  ref: "noopener noreferrer"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Buy me a coffee ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "(link will open in a new window)", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "footer__copyright" }, [
  /*#__PURE__*/_createTextVNode(" Made with "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text--ci",
    "aria-hidden": "true"
  }, "♥"),
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "love"),
  /*#__PURE__*/_createTextVNode(" by "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://github.com/nkosakul",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Nattaphong Kosakul")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("small", _hoisted_3, [
        _createElementVNode("a", _hoisted_4, _hoisted_7, 512)
      ]),
      _hoisted_8
    ])
  ]))
}